import storageService from '../storage'

export class APIError extends Error {
  code
  constructor(message, code, response, errorObj) {
    super()
    this.message = message
    this.code = code ?? ''
    this.response = response
    this.error = errorObj
  }
}

export const responseErrorInterceptor = error => {
  const message = error.response?.data
  const code = error.response?.status

  if (code === 401) {
    if (storageService.get('user') !== undefined) {
      console.log('401!')
      storageService.remove('user')
      window.location.replace('/')
    }
  }

  throw new APIError(message, code, error.response, error)
}

export const responseSuccessInterceptor = response => {
  return response
}
